package es.subastia.splash

import androidx.compose.animation.core.Animatable
import androidx.compose.animation.core.tween
import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.unit.dp
import androidx.compose.material3.MaterialTheme
import es.subastia.navigation.NavRoute
import es.subastia.navigation.Navigator
import kotlinx.coroutines.delay
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import org.jetbrains.compose.ui.tooling.preview.Preview
import org.koin.compose.viewmodel.koinViewModel
import subastia.composeapp.generated.resources.Res
import subastia.composeapp.generated.resources.desc_splash_screen_logo
import subastia.composeapp.generated.resources.ic_subastia

@Composable
fun SplashScreen(
    navigator: Navigator,
) {
    val viewModel: SplashViewModel = koinViewModel()
    val destination by viewModel.destination.collectAsState()

    LaunchedEffect(destination) {
        if (destination !is SplashDestination.Loading) {
            when (destination) {
                is SplashDestination.Main -> navigator.replaceAll(listOf(NavRoute.Main))
                is SplashDestination.Loading -> {}
            }
        }
    }

    SplashScreenContent()
}

@Composable
fun SplashScreenContent() {
    val alpha = remember { Animatable(0f) }

    LaunchedEffect(Unit) {
        alpha.animateTo(
            targetValue = 1f,
            animationSpec = tween(durationMillis = 1500),
        )
    }

    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center,
    ) {
        Image(
            painter = painterResource(Res.drawable.ic_subastia),
            contentDescription = stringResource(Res.string.desc_splash_screen_logo),
            modifier = Modifier
                .size(150.dp)
                .alpha(alpha.value),
        )
    }
}

@Composable
@Preview
fun SplashScreenPreview() {
    MaterialTheme {
        SplashScreenContent()
    }
}
